export const SEARCH_PERFORM_STARTED = 'SEARCH_PERFORM_STARTED';
export const SEARCH_PERFORM_FAILED = 'SEARCH_PERFORM_FAILED';
export const SEARCH_PERFORM_SUCCESS = 'SEARCH_PERFORM_SUCCESS';
export const SEARCH_RESET = 'SEARCH_RESET';
export const SEARCH_SET_TEXT = 'SEARCH_SET_TEXT';
export const SEARCH_SET_KEYS = 'SEARCH_SET_KEYS';
